var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"healthdetail"},[_c('MyVideo',{staticClass:"heal_video",attrs:{"id":"video","src":_vm.mediaurl,"poster":_vm._f("videoposter")(_vm.mediaurl)},on:{"send":_vm.send}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }